import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import { FolderPlus, Trash2 } from "lucide-react";

export default function Liste() {
  const [lists, setLists] = useState([]);
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");

  const reload = () => api.get("/lists").then(r => setLists(r.data));
  useEffect(() => { reload(); }, []);

  const create = async () => {
    if (!name.trim()) return;
    await api.post("/lists", { name: name.trim(), description: desc });
    setName(""); setDesc(""); setShow(false);
    reload();
  };

  const remove = async (id) => {
    if (!window.confirm("Eliminare la lista? L'azione non è reversibile.")) return;
    await api.delete(`/lists/${id}`);
    reload();
  };

  return (
    <div data-testid="liste-page">
      <div className="flex justify-between items-center mb-6">
        <div>
          <div className="h-display">Liste lead</div>
          <div className="text-muted mt-2">Le tue liste di lavorazione</div>
        </div>
        <button onClick={()=>setShow(true)} className="btn btn-primary" data-testid="create-list-btn">
          <FolderPlus size={16}/> Nuova lista
        </button>
      </div>

      {lists.length === 0 ? (
        <div className="card text-center" style={{padding:60}}>
          <FolderPlus size={48} color="var(--mv-text-light)" style={{margin:"0 auto 16px"}} />
          <div className="h-section mb-2">Nessuna lista ancora</div>
          <div className="text-muted">Crea una lista per iniziare a lavorare i lead</div>
        </div>
      ) : (
        <div className="grid gap-4" style={{gridTemplateColumns:"repeat(auto-fit, minmax(320px,1fr))"}}>
          {lists.map(l => (
            <div key={l.id} className="card card-hover" data-testid={`list-card-${l.id}`}>
              <div className="flex justify-between items-start mb-3">
                <Link to={`/liste/${l.id}`} style={{color:"inherit",textDecoration:"none",flex:1}}>
                  <div className="h-card">{l.name}</div>
                  {l.description && <div className="text-small text-muted mt-2">{l.description}</div>}
                </Link>
                <button onClick={()=>remove(l.id)} className="btn btn-ghost btn-sm" data-testid={`delete-list-${l.id}`}><Trash2 size={14}/></button>
              </div>
              <div className="flex gap-2 mt-4" style={{flexWrap:"wrap"}}>
                <span className="badge badge-gray">{l.totalItems || 0} aziende</span>
                {l.counts?.screened > 0 && <span className="badge badge-orange">{l.counts.screened} screened</span>}
                {l.counts?.analyzed > 0 && <span className="badge badge-green">{l.counts.analyzed} analyzed</span>}
                {l.counts?.email_sent > 0 && <span className="badge badge-brand">{l.counts.email_sent} email inviate</span>}
              </div>
              <Link to={`/liste/${l.id}`} className="btn btn-secondary btn-sm w-full mt-4" data-testid={`open-list-${l.id}`}>Apri lista</Link>
            </div>
          ))}
        </div>
      )}

      {show && (
        <div className="modal-backdrop" onClick={()=>setShow(false)}>
          <div className="modal" onClick={e=>e.stopPropagation()}>
            <div className="h-section mb-4">Nuova lista</div>
            <label className="label">Nome</label>
            <input className="input" value={name} onChange={e=>setName(e.target.value)} placeholder='Es. "Dentisti Milano Q1 2026"' data-testid="new-list-name-input" />
            <div style={{height:12}}/>
            <label className="label">Descrizione (opzionale)</label>
            <textarea className="textarea" value={desc} onChange={e=>setDesc(e.target.value)} data-testid="new-list-desc-input"></textarea>
            <div className="flex gap-2 justify-between mt-6">
              <button onClick={()=>setShow(false)} className="btn btn-secondary">Annulla</button>
              <button onClick={create} className="btn btn-primary" disabled={!name.trim()} data-testid="confirm-create-list">Crea lista</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
